import { render, staticRenderFns } from "./hakakses.vue?vue&type=template&id=80cba5ec"
import script from "./hakakses.vue?vue&type=script&lang=js"
export * from "./hakakses.vue?vue&type=script&lang=js"
import style0 from "./hakakses.vue?vue&type=style&index=0&id=80cba5ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports